import { render, staticRenderFns } from "./ApplyReactivate.vue?vue&type=template&id=2f734318&"
import script from "./ApplyReactivate.vue?vue&type=script&lang=ts&"
export * from "./ApplyReactivate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports